import React from "react";
import styled from "../../lib/styled";

interface GalleryImageProps {
  coverImage: string;
  name: string;
}
export const ShopSection: React.FC<GalleryImageProps> = (props) => {
  return (
    <Wrapper>
      {props.name && <SectionName>{props.name}</SectionName>}
      <CoverImage image={props.coverImage} />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  overflow: hidden;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 830px;
  height: 200px;
  background-color: ${({ theme }) => theme.color.darkThree};
  margin-bottom: 15px;
`;

const SectionName = styled.div`
  position: absolute;
  z-index: 10;
  font-family: "Keep Calm";
  letter-spacing: 2px;
  color: white;
  text-shadow: 0 0 3px #00000073;
  text-transform: uppercase;
  text-align: center;
`;

const CoverImage = styled.div<{ image: string }>`
  width: 100%;
  height: 100%;
  background-image: ${({ image }) => `url(${image})`};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: absolute;
`;
